import React from 'react'
import * as Icon from 'react-feather'

const navigationConfig = [
  {
    type: 'groupHeader',
    groupTitle: 'Google Business Profile',
  },
  {
    id: 'home',
    title: 'Home',
    type: 'item',
    icon: <Icon.Home size={20} />,
    navLink: '/',
  },
  {
    id: 'locations',
    title: 'Locations',
    type: 'collapse',
    permission: ['locations', 'edits', 'notifications'],
    icon: <Icon.MapPin size={20} />,
    children: [
      {
        id: 'myLocations',
        title: 'My Locations',
        type: 'item',
        permission: ['locations'],
        icon: <Icon.Circle size={12} />,
        navLink: '/locations/list',
      },
      {
        id: 'pendingEdits',
        title: 'Pending Edits',
        type: 'item',
        permission: ['edits'],
        icon: <Icon.Circle size={12} />,
        navLink: '/locations/pending',
      },
      {
        id: 'performance',
        title: 'Performance',
        type: 'item',
        permission: ['locations'],
        icon: <Icon.Circle size={12} />,
        navLink: '/locations/score',
      },
      {
        id: 'services',
        title: 'Services',
        type: 'item',
        permission: ['services'],
        icon: <Icon.Circle size={12} />,
        navLink: '/services/hub',
      },
      {
        id: 'notifications',
        title: 'Notifications',
        type: 'item',
        permission: ['notifications'],
        icon: <Icon.Circle size={12} />,
        navLink: '/notifications',
      },
    ],
  },
  {
    id: 'posts',
    title: 'Posts',
    type: 'collapse',
    icon: <Icon.Edit size={20} />,
    permission: ['posts', 'schedules'],
    children: [
      {
        id: 'new_offer',
        title: 'Add Offer',
        type: 'item',
        permission: ['posts'],
        icon: <Icon.Circle size={12} />,
        navLink: '/posts/offer',
      },
      {
        id: 'new_cta',
        title: "What's New",
        type: 'item',
        permission: ['posts'],
        icon: <Icon.Circle size={12} />,
        navLink: '/posts/cta',
      },
      {
        id: 'new_event',
        title: 'Event',
        type: 'item',
        permission: ['posts'],
        icon: <Icon.Circle size={12} />,
        navLink: '/posts/event',
      },
      {
        id: 'schedules',
        title: 'Schedules',
        type: 'item',
        permission: ['schedules'],
        icon: <Icon.Circle size={12} />,
        navLink: '/publications',
      },
    ],
  },
  {
    id: 'bulkEdit',
    title: 'Bulk Edit',
    type: 'collapse',
    icon: <Icon.Map size={20} />,
    permission: ['infos'],
    children: [
      {
        id: 'bulkEditGeneral',
        title: 'General',
        type: 'item',
        permission: ['infos'],
        icon: <Icon.Circle size={12} />,
        navLink: '/locations/edit/general',
      },
      {
        id: 'bulkEditImages',
        title: 'Images',
        type: 'item',
        permission: ['infos'],
        icon: <Icon.Circle size={12} />,
        navLink: '/locations/edit/images',
      },
      ...(process.env.REACT_APP_REMOVE_QA === 'true'
        ? []
        : [
            {
              id: 'questionsAndAnswer',
              title: 'FAQ',
              type: 'item',
              permission: ['infos'],
              icon: <Icon.Circle size={12} />,
              navLink: '/answered-questions',
            },
          ]),
      {
        id: 'socialMedia',
        title: 'Social Media',
        type: 'item',
        permission: ['infos'],
        icon: <Icon.Circle size={12} />,
        navLink: '/locations/edit/social-media',
      },
      {
        id: 'bulkEditActionLinks',
        title: 'Action Links',
        type: 'item',
        permission: ['infos'],
        icon: <Icon.Circle size={12} />,
        navLink: '/locations/edit/action-links',
      },
      {
        id: 'bulkEditUpdateCSV',
        title: 'Import CSV',
        type: 'item',
        permission: ['infos'],
        icon: <Icon.Circle size={12} />,
        navLink: '/locations/edit/import',
      },
    ],
  },
  {
    id: 'sac',
    title: 'SAC',
    type: 'collapse',
    permission: ['reviews', 'nps'],
    icon: <Icon.Star size={20} />,
    children: [
      {
        id: 'reviews',
        title: 'Reviews',
        type: 'item',
        icon: <Icon.Circle size={12} />,
        navLink: '/reviews',
        permission: ['reviews'],
      },
      {
        id: 'nps',
        title: 'NPS',
        type: 'item',
        icon: <Icon.Circle size={12} />,
        navLink: '/nps',
        permission: ['nps'],
      },
    ],
  },
  {
    id: 'insights',
    title: 'Insights',
    type: 'collapse',
    icon: <Icon.BarChart2 size={20} />,
    permission: ['insights', 'keywords'],
    subscribed: true,
    children: [
      {
        id: 'insightsMetrics',
        title: 'Metrics',
        type: 'item',
        icon: <Icon.Circle size={12} />,
        navLink: '/insights',
        permission: ['insights'],
      },
      {
        id: 'insightsReputation',
        title: 'Reputation',
        type: 'item',
        icon: <Icon.Circle size={12} />,
        navLink: '/insights/reputation',
        permission: ['insights'],
      },
      {
        id: 'insightsKeywords',
        title: 'Keywords',
        type: 'item',
        icon: <Icon.Circle size={12} />,
        navLink: '/insights/keywords',
        permission: ['keywords'],
      },
      {
        id: 'insightsLocations',
        title: 'Locations',
        type: 'item',
        icon: <Icon.Circle size={12} />,
        navLink: '/insights/locations',
        permission: ['insights'],
      },
      {
        id: 'InsightsMenbers',
        title: 'Members',
        type: 'item',
        icon: <Icon.Circle size={12} />,
        navLink: '/insights/members',
        permission: ['insights'],
      },
    ],
  },
  {
    id: 'help',
    title: 'Help Center',
    type: 'item',
    icon: <Icon.HelpCircle size={16} />,
    navLink: '/help-center',
  },
]

export default navigationConfig
